<div class="client-layout" [class.client-layout--subpage]="hideMobileChrome">
  @if (!hideMobileChrome) {
    <app-client-mobile-header class="client-layout__header-mobile"></app-client-mobile-header>
  }

  <div class="client-scroll" #scrollContainer>
    <app-header class="client-layout__header-desktop"></app-header>

    <main class="client-content">
      <router-outlet></router-outlet>
      <app-footer class="client-layout__footer-desktop"></app-footer>
    </main>
  </div>

  @if (!hideMobileChrome) {
    <app-client-mobile-tabbar class="client-layout__tabbar-mobile"></app-client-mobile-tabbar>
  }
</div>
